import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import {
  CreateCommentRequest,
  GetCommentsRequestParams,
  UpdateCommentRequest,
} from '@/types/requests/comments'
import { CommentCollection } from '@/types/responses/comments'

class CommentService {
  private endpoint = `${API_PATH_INTERNAL}/comments`

  async getComments(
    params: GetCommentsRequestParams,
  ): Promise<CommentCollection> {
    const response = await apiService.get(`${this.endpoint}`, { params })

    return response.data
  }

  async createComment(request: CreateCommentRequest): Promise<unknown> {
    const response = await apiService.post(`${this.endpoint}`, request)

    return response.data
  }

  async updateComment(
    commentId: number,
    request: UpdateCommentRequest,
  ): Promise<unknown> {
    const response = await apiService.patch(
      `${this.endpoint}/${commentId}`,
      request,
    )

    return response.data
  }

  async deleteComment(commentId: number): Promise<unknown> {
    const response = await apiService.delete(`${this.endpoint}/${commentId}`)

    return response.data
  }

  async togglePinStatus(commentId: number): Promise<unknown> {
    const response = await apiService.patch(
      `${this.endpoint}/${commentId}/toggle-pin-status`,
      {},
    )

    return response.data
  }
}

const commentService = new CommentService()

export default commentService
